import React from 'react';

export function GoogleMapsIcon({ size = 18, className = '', style = {} }) {
  // Height calculated to maintain the classic 32:44 map-pin aspect ratio
  const width = typeof size === 'number' ? size : 18;
  const height = Math.round(width * (44 / 32));

  return (
    <svg
      viewBox="0 0 32 44"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.22))',
        ...style
      }}
      aria-hidden="true"
    >
      {/* Top-Left: Google Blue */}
      <path
        d="M16 2C8.27 2 2 8.27 2 16c0 4.14 1.8 7.86 4.67 10.42L16 16V2Z"
        fill="#4285F4"
      />
      {/* Top-Right: Google Red */}
      <path
        d="M16 2V16L25.33 26.42C28.2 23.86 30 20.14 30 16c0-7.73-6.27-14-14-14Z"
        fill="#EA4335"
      />
      {/* Bottom-Left: Google Green */}
      <path
        d="M6.67 26.42C9.4 30.08 13.06 35.54 16 42V16L6.67 26.42Z"
        fill="#34A853"
      />
      {/* Bottom-Right: Google Yellow */}
      <path
        d="M16 16V42C18.94 35.54 22.6 30.08 25.33 26.42L16 16Z"
        fill="#FBBC04"
      />
      {/* Inner White Center Disc */}
      <circle cx="16" cy="16" r="6" fill="#FFFFFF" />
    </svg>
  );
}

export default GoogleMapsIcon;
